import { Link } from "react-router-dom";
import { FiBriefcase, FiUserPlus } from "react-icons/fi";
import "../../styles/auth.css";
import "../../styles/users.css";

export default function ApkRegisterHub() {
  return (
    <div className="auth-container">
      <div className="auth-card apk-register-hub" style={{ maxWidth: 560, width: "100%" }}>
        <h2>Get started with Fast Recovery</h2>
        <p className="muted">
          Repo agency registration is free. After OTP, pay ₹100 for Super Admin
          verification. Each user activation is ₹100. Agents join with a repo agency
          code from their repo admin.
        </p>

        <div className="apk-register-options">
          <Link to="/register-company" className="apk-register-option">
            <span className="apk-register-option__icon">
              <FiBriefcase aria-hidden />
            </span>
            <div>
              <strong>Register a new repo agency</strong>
              <p>
                Create your repo agency and admin account for free. Pay ₹100 for
                Super Admin verification. Each user activation is ₹100 — no free user.
              </p>
            </div>
          </Link>

          <Link to="/agent-register" className="apk-register-option">
            <span className="apk-register-option__icon">
              <FiUserPlus aria-hidden />
            </span>
            <div>
              <strong>Join as repo user / agent</strong>
              <p>
                Use the repo agency code from your repo admin. Your account stays
                inactive until the admin activates you.
              </p>
            </div>
          </Link>
        </div>

        <p className="auth-link" style={{ marginTop: 20 }}>
          <Link to="/">← Back to login portal</Link>
        </p>
      </div>
    </div>
  );
}
